'use client';
import classnames from 'classnames';
import React, { Fragment, useState } from 'react';
import { wrapField } from '../../hooks/useForm';
import ErrorLabel from '../ErrorLabel';
import styles from './radioSelectInput.module.scss';
import { SelectIcon } from './SelectIcon';
export var Themes;
(function (Themes) {
    Themes["PRIMARY"] = "primary";
    Themes["CHIPS"] = "chips";
})(Themes || (Themes = {}));
const RadioSelectInput = React.forwardRef(({ className = '', id, onChange, onBlur, value, options, error, horizontal = false, theme = Themes.PRIMARY, }, ref) => {
    const [focus, setFocus] = useState(null);
    return (<span className={classnames(styles.radioButtonGroup, { [styles.useColumn]: !horizontal }, className)}>
        {options.map((radioButton) => {
            const isSelected = value === radioButton.value;
            const isFocused = focus === radioButton.value;
            const isDisabled = radioButton.disabled;
            const isError = !!error;
            return (<Fragment key={`option-${id}_${radioButton.value}`}>
              <label key={radioButton.value} htmlFor={`${id}_${radioButton.value}`} className={classnames(styles.optionContainer, {
                    [styles.horizonalOptionContainer]: horizontal,
                    [styles.noHover]: theme === Themes.CHIPS || isDisabled,
                    [styles.disabled]: isDisabled,
                    [styles.hasSubLabel]: radioButton.subLabel,
                })}>
                <input id={`${id}_${radioButton.value}`} type='radio' name={radioButton.label} checked={value === radioButton.value} value={radioButton.value} onFocus={() => setFocus(radioButton.value)} className={classnames(styles.hiddenInput, { [styles.disabled]: isDisabled })} onChange={() => {
                    onChange(radioButton.value);
                }} onBlur={onBlur} ref={ref} disabled={isDisabled}/>
                {theme !== Themes.CHIPS && (<SelectIcon selected={isSelected} focused={isFocused} disabled={isDisabled} error={isError}/>)}
                <span className={classnames(styles.label, {
                    [styles.chipsLabel]: theme === Themes.CHIPS,
                    [styles.checked]: isSelected,
                })}>
                  {radioButton.label}
                  {radioButton.subLabel ? (<span className={styles.subLabel}>{radioButton.subLabel}</span>) : null}
                </span>
              </label>
            </Fragment>);
        })}

        {error && <ErrorLabel error={error}/>}
      </span>);
});
RadioSelectInput.displayName = 'RadioSelectInput';
export const RadioSelectInputField = wrapField(RadioSelectInput);
export default RadioSelectInput;
